export const formatRows = (listaItems) => 
  
  listaItems.map((item) => ({
      id: item.art_Id,
      prd_code: item?.prd_code,
      art_descripcion: item?.orderhistdet_art?.art_descripcion || "",
      price: item?.ode_price || 0,
      quantity: item?.ode_quantity || 0,
      observacion: item?.ode_observacion || 0,
      total_amount: item?.ode_total_amount || 0,
    }));
